import React from 'react';
import { AuthProvider } from './contexts/AuthContext'; // Adjust the path as necessary
import AppRouter from './AppRouter';
import './variables.css';

function App() {
  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
}

export default App;
